import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import logo2 from '../../public/logo2.png'
import image1 from '../../public/image1.png'
import useSWR from 'swr';

import {
  ChevronLeft,
  ChevronRight,
  Users,
  MapPin,
  Receipt,
  Smartphone,
  UserCheck,
  Package,
  ShoppingCart,
  User,
  LogOut,Ticket,
  Settings, LayoutDashboard,
} from "lucide-react";

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useUserContext } from "../context/DealerProfile.jsx";

// Map module names to icons
const iconMap = {
  "Home": LayoutDashboard,
  "Dashboard": LayoutDashboard,
  "Tickets": Ticket,
  "Indent Request": Package,
  "Sales Orders": ShoppingCart,
  "Contact": User,
};


// Map subroutes to main sidebar routes
const subRouteMap = {
  "/owner-details": "/potential-donor",
  "/contact-details": "/existing-donor",
  "/task-details": "/tasks",
  "/task-edit": "/tasks",
  "/call-details": "/manual-calls",
  "/payment-details": "/payments",
  "/create-lead": "/potential-donor",
  "/edit-lead": "/potential-donor"
  // Add more mappings as needed
};

export default function Sidebar() {
  // const [expanded, setExpanded] = useState(true);

  // Auto-collapse on smaller screens (< 665px)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 665) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);


  useEffect(() => {
    function parseQueryToObj(url) {
      const queryStartIndex = url.indexOf("?");
      if (queryStartIndex !== -1) {
        const queryString = url.substring(queryStartIndex + 1);
        const pairs = queryString.split("&");
        const queryObj = {};
        pairs.forEach((pair) => {
          const [key, value] = pair.split("=");
          if (key) {
            queryObj[decodeURIComponent(key)] = decodeURIComponent(value || "");
          }
        });
        return queryObj;
      }
      return {};
    }

    const url = window.location.href;
    const parsedQueryObj = parseQueryToObj(url);
    const appUrl = parsedQueryObj?.["some_url"];
    // console.log("ParsedQueryObj",{ parsedQueryObj });
    if (appUrl) {
      const pathToNavigate = `/${appUrl.replace("/app", "")}`;
      setTimeout(() => {
        navigate(pathToNavigate, { replace: true });
      }, 0);
    }

  }, [navigate]);
  const location = useLocation();
  const [expanded, setExpanded] = useState(true);
  const [routes, setRoutes] = useState([]);




  const { dealerDetail, error } = useUserContext();

  // console.log({dealerDetail});
  // 🚫 BLOCK IF USER IS INACTIVE



  const handleLogout = () => {
    const redirectURL = "/__catalyst/auth/login";
    window.catalyst.auth.signOut(redirectURL);
  };



  const fetcher = url => axios.get(url).then(res => res.data?.data || []);

  const { data = [], isLoading } = useSWR(
    '/server/dealer_backend/getSidebarItems',
    fetcher,
    {
      revalidateOnFocus: false,     // ❌ don’t refetch on window focus
      revalidateOnReconnect: false, // ❌ don’t refetch on reconnect
      refreshInterval: 0,           // ❌ no polling
    }
  );


  // Filter logic (reacts to both data and dealerDetail)
  let filteredData = data;

  const donorType = dealerDetail?.Donor_Type?.trim().toLowerCase();

  if (donorType === 'potential donor') {
    filteredData = filteredData.filter(name => name !== 'Existing Donor');
  } else if (donorType === 'existing donor') {
    filteredData = filteredData.filter(name => name !== 'Potential Donor');
  }

  const restrictedEmailForPotentialDonor = [
    "Annu.kumari@planindia.org",
    "Asha.singh@planindia.org",
    "Nirmal.deka@planindia.org",
  ];

  const restrictedEmailForExistingDonor = [
    "Samar.dhara@planindia.org",
    "Santhosh.uthappa@planindia.org",
  ];

  if (restrictedEmailForPotentialDonor.includes(dealerDetail?.Email)) {
    filteredData = filteredData.filter(name => name !== 'Potential Donor');
  }

  if (restrictedEmailForExistingDonor.includes(dealerDetail?.Email)) {
    filteredData = filteredData.filter(name => name !== 'Existing Donor');
  }
  const homeRoute = {
    name: "Home",
    path: "/",
    icon: LayoutDashboard,
  };


  const formattedRoutes = [
    homeRoute,
    ...filteredData.map(name => ({
      name,
      path: `/${name.toLowerCase().replace(/\s+/g, "-")}`,
      icon: iconMap[name] || LayoutDashboard,
    })),
  ];



  const matchedPath =
    Object.entries(subRouteMap).find(([sub]) =>
      location.pathname.startsWith(sub)
    )?.[1] || location.pathname;

  // 🚫 BLOCK IF USER IS INACTIVE
  useEffect(() => {
    if (dealerDetail?.User_Status === "Inactive") {
      navigate("/unauthorized");
    }
  }, [dealerDetail, navigate]);

  if (dealerDetail?.User_Status === "Inactive") {
    return (
      <div className="flex items-center justify-center h-screen w-full bg-gray-100 text-red-600 text-xl font-semibold">
        You are not allowed to view this data. Please contact admin.
      </div>
    );
  }

  const hideChevronRoutes = [
    "/owner-details",
    "/contact-details",
    "/account-details",
    "/call-details",
    "/payment-details",
    "/task-details",
    "/script-details"
  ];

  // Check if current path starts with any of those routes
  const hideChevron = hideChevronRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <aside className={`h-screen custom-scroll-bar text-white bg-gray-900 transition-all overflow-y-auto duration-300 ease-in-out ${expanded ? "w-64" : "w-20"}`} style={{ borderRight: "1px solid #E5E7EB" }}>
      <div className="flex flex-col h-screen justify-between bg-gray-900 text-white">
        <div className="p-4 flex items-center justify-between">
          <Link to={"/"}>
            <div className="flex items-center space-x-2">
              {/* Logo (smaller when collapsed, larger when expanded) */}
              <div
                className={`border-2 rounded-full overflow-hidden mr-[3px] transition-all duration-300 bg-white backdrop-blur-sm
  ${expanded ? "w-[51px] h-[44.5px]" : "w-8 h-8"}
`}
              >
                <img src={logo2} alt="logo" className="w-full h-full object-contain" />
              </div>

              {/* Text only when expanded */}
              {expanded && (
                <span
                  className="text-white font-bold"
                  style={{
                    fontFamily: `'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
                    fontSize: "18px",
                    textAlign: "left",
                  }}
                >
                   Dunham Bush
                </span>
              )}
            </div>
          </Link>

          {/* Chevron Button */}
          {!hideChevron && (
            <button
              onClick={() => setExpanded(!expanded)}
              className={`${expanded ? "ml-3" : "ml-0 self-start"
                } hover:bg-[#4F565D] rounded-full p-1 transition`}
              aria-label={expanded ? "Collapse sidebar" : "Expand sidebar"}
            >
              {expanded ? (
                <ChevronLeft className="h-5 w-5" />
              ) : (
                <ChevronRight className="h-5 w-5" />
              )}
            </button>
          )}
        </div>


        {/* Menu navigation */}
        <nav className="flex-grow overflow-y-auto my-3">
          <ul className="space-y-1 px-2 mt-3">
            {formattedRoutes.map(route => {
              const isActive =
                route.path === "/"
                  ? matchedPath === "/"
                  : matchedPath.startsWith(route.path);

              return (
                <li key={route.path}>
                  <Link
                    to={route.path}
                    className={`group flex items-center gap-3 px-3 py-2 transition
                      rounded-md cursor-pointer
                     
                      ${isActive
                        ? "bg-[#4F565D] text-white font-bold border-l-4 border-[#2171B6] shadow"
                        : "hover:bg-[#4F565D] hover:text-white"}
                      ${expanded ? "justify-start" : "justify-center"}
                    `}
                    aria-current={isActive ? "page" : undefined}
                  >
                    <route.icon className={`h-5 w-5 flex-shrink-0 transition-colors ${isActive ? "text-white" : "text-white group-hover:text-white"}`} />
                    {expanded && (
                      <span className="transition-opacity duration-150 truncate">
                        {route.name}
                      </span>
                    )}
                  </Link>
                </li>
              );
            })}

            {showLogoutModal && (
              <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg shadow-lg p-6 w-80">
                  {/* <h2 className="text-lg font-semibold mb-4">Confirm Logout</h2> */}
                  <p className="mb-6 text-black">Are you sure you want to logout?</p>
                  <div className="flex justify-end space-x-4">
                    <button
                      className="px-4 py-2 text-gray-700 hover:text-black"
                      onClick={() => setShowLogoutModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            )}


            {/* Logout */}
            <li className="mt-2">
              <button
                className={`flex w-full items-center gap-3 px-3 py-2 text-red-600 rounded-md hover:bg-red-100 hover:text-red-700 transition justify-${expanded ? "start" : "center"}`}
                onClick={() => setShowLogoutModal(true)}
              >
                <LogOut className="h-5 w-5" />
                {expanded && <span className="font-medium">Logout</span>}
              </button>
            </li>
          </ul>
        </nav>



        <div
          className={`p-2 border-t border-[#2B3544] transition-all duration-300 ${expanded ? "flex items-center space-x-4" : "flex flex-col items-center space-y-2"
            }`}
        >
          {/* Avatar */}
          <Link to="/profile">
            <img src={`profile.png`}
              alt={dealerDetail?.First_Name || "User"}
              className="w-10 h-10 rounded-full object-cover border border-gray-300"
            />
          </Link>


          {/* Name Display */}
          {dealerDetail?.First_Name && (() => {
            const [firstName, ...lastNameParts] = dealerDetail.First_Name.trim().split(" ");
            const lastName = lastNameParts.join(" ");

            return (
              <div
                className={`text-white  transition-all duration-300 ${expanded ? "text-l flex flex-col" : "text-center text-xs"
                  }`}
              >
                {expanded ? (
                  <span>Hello {dealerDetail.First_Name}</span>
                ) : (
                  <>
                    <div>{firstName}</div>
                    <div>{lastName}</div>
                  </>
                )}
              </div>
            );
          })()}

          {/* Settings Icon */}
          {/* {expanded && (
            <button
              className="ml-auto text-gray-400 hover:text-gray-600 transition"
              aria-label="Profile settings"
            // onClick={() => ...}
            >
              <Settings className="w-5 h-5" />
            </button>
          )} */}
        </div>




        {/* Footer */}
        <div className={`border-t border-[#2B3544] py-1 px-2 text-xs text-gray-400 ${expanded ? "text-left" : "text-center"}`}>
          <span>© 2026 Extension Technologies</span>
        </div>



      </div>
    </aside>
  );
}
